import AnimatedIcon from "../../reels/AnimatedIcon";
import WildTextAnim from "../../reels/WildTextAnim";
import { Graphics } from "pixi.js";
import { GameConfigs } from "./GameConfigs";
import { isDesktop } from "react-device-detect";

let mult = isDesktop ? 1 : 0.5;

export const ReelConfigMobile = {
  width: 5,
  height: 3,
  iconWidth: 232 / 2,
  iconHeight: 229 / 2,
  iconRealWidth: 216 / 2,
  iconRealHeight: 216 / 2,
  iconGap: 7 / 2,
  baitTime: 1000,
  scatterCodes: [10],
  divider: "reel_divider",
  border: "reel_border",
  reelsMask: false,
  animations: {
    bg: {
      pattern: "frm_000$.png",
      start: 0,
      end: 23,
      speed: 0.5,
      loop: true,
    },
  },
  icons: [
    {
      id: 0,
      IconClass: AnimatedIcon,
      icon: "TEN_00000.png",
      iconBlurred: "minor_5_blurred",
      type: "minor",
      animation: {
        fg: {
          pattern: "TEN_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.72,
            y: 0.72,
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "ten",
    },
    {
      id: 1,
      IconClass: AnimatedIcon,
      icon: "J_00000.png",
      iconBlurred: "minor_4_blurred",
      type: "minor",
      animation: {
        fg: {
          pattern: "J_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.72,
            y: 0.72,
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "jack",
    },
    {
      id: 2,
      IconClass: AnimatedIcon,
      icon: "Q_00000.png",
      iconBlurred: "minor_3_blurred",
      type: "minor",
      animation: {
        fg: {
          pattern: "Q_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.72,
            y: 0.72,
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "queen",
    },
    {
      id: 3,
      IconClass: AnimatedIcon,
      icon: "K_00000.png",
      //   iconBg: "minor_2_bg",
      iconBlurred: "minor_2_blurred",
      type: "minor",
      animation: {
        fg: {
          pattern: "K_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.72,
            y: 0.72,
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "king",
    },
    {
      id: 4,
      IconClass: AnimatedIcon,
      icon: "A_00000.png",
      //   iconBg: "minor_1_bg",
      iconBlurred: "minor_1_blurred",
      type: "minor",
      animation: {
        fg: {
          pattern: "A_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.72,
            y: 0.72,
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "ace",
    },
    {
      id: 5,
      IconClass: AnimatedIcon,
      icon: "cigar_00000.png",
      // iconBg: "major_5_bg",
      iconBlurred: "major_5_blurred",
      iconBorder: "major_5_frame",
      type: "major",
      animation: {
        fg: {
          pattern: "cigar_000$.png",
          start: 0,
          end: 23,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
        // frame: {
        //   pattern: "charframe$.png",
        //   start: 0,
        //   end: 71,
        //   speed: 0.5,
        //   loop: true,
        //   scale: {
        //     x: 0.96,
        //     y: 0.96,
        //   },
        // },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "samurai",
    },
    {
      id: 6,
      IconClass: AnimatedIcon,
      icon: "Cocktail_00000.png",
      // iconBg: "major_4_bg",
      iconBlurred: "major_4_blurred",
      iconBorder: "major_4_frame",
      type: "major",
      animation: {
        fg: {
          pattern: "Cocktail_000$.png",
          start: 0,
          end: 47,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
        // frame: {
        //   pattern: "charframe$.png",
        //   start: 0,
        //   end: 71,
        //   speed: 0.5,
        //   loop: true,
        //   scale: {
        //     x: 0.96,
        //     y: 0.96,
        //   },
        // },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "geisha",
    },
    {
      id: 7,
      IconClass: AnimatedIcon,
      icon: "Kalisha_00000.png",
      // iconBg: "major_3_bg",
      iconBlurred: "major_3_blurred",
      type: "major",
      iconBorder: "major_3_frame",
      animation: {
        fg: {
          pattern: "Kalisha_000$.png",
          start: 0,
          end: 47,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
        // frame: {
        //   pattern: "charframe$.png",
        //   start: 0,
        //   end: 71,
        //   speed: 0.5,
        //   loop: true,
        //   scale: {
        //     x: 0.96,
        //     y: 0.96,
        //   },
        // },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "emperess",
    },
    {
      id: 8,
      IconClass: AnimatedIcon,
      icon: "Hera_00000.png",
      iconBlurred: "major_2_blurred",
      // iconBg: "major_2_bg",
      type: "major",
      iconBorder: "major_2_frame",
      animation: {
        fg: {
          pattern: "Hera_000$.png",
          start: 0,
          end: 47,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
        // frame: {
        //   pattern: "charframe$.png",
        //   start: 0,
        //   end: 71,
        //   speed: 0.5,
        //   loop: true,
        //   scale: {
        //     x: 0.96,
        //     y: 0.96,
        //   },
        // },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "minister",
    },
    {
      id: 9,
      IconClass: AnimatedIcon,
      icon: "tommy_00000.png",
      // iconBg: "major_1_bg",
      iconBlurred: "major_1_blurred",
      type: "major",
      iconBorder: "major_1_frame",
      animation: {
        fg: {
          pattern: "tommy_000$.png",
          start: 0,
          end: 47,
          speed: 0.5,
          loop: false,
          precision: 2,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
        // frame: {
        //   pattern: "charframe$.png",
        //   start: 0,
        //   end: 71,
        //   speed: 0.5,
        //   loop: true,
        //   scale: {
        //     x: 0.96,
        //     y: 0.96,
        //   },
        // },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "general",
    },
    {
      id: 10,
      IconClass: AnimatedIcon,
      Fg2Class: WildTextAnim,
      icon: "scatter_00000.png",
      //   iconBg: "scatter_bg",
      type: "scatter",
      iconBlurred: "scatter_blurred",
      isScatter: true,
      animation: {
        fg: {
          pattern: "scatter_000$.png",
          start: 0,
          end: 47,
          speed: 0.5,
          loop: false,
          precision: 2,
          scale: {
            x: 0.96,
            y: 0.96,
          },
          sound: "scatter_impact_sfx",
          // offsetX: 0,
          // offsetY: -15
        },
        fg2Index: 0,
        fg2Data: [
          {
            pattern: "Scatter_000$.png",
            start: 0,
            end: 24,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: 6,
            offsetY: 150 / 2,
          },
        ],
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "scatter",
    },
    {
      id: 11,
      IconClass: AnimatedIcon,
      Fg2Class: WildTextAnim,
      icon: "money00.png",
      iconBgRotate: "wild_bg",
      iconBg: "wild_bg",
      iconBgBonus: "stickybg_00000.png",
      type: "wild",
      iconBlurred: "wild_blurred",
      isWild: true,
      isSticked: false,
      animation: {
        // frame: {
        //   pattern: "wildframe$.png",
        //   start: 0,
        //   end: 23,
        //   speed: 0.5,
        //   loop: true,
        //   offsetX: -10,
        //   offsetY: -13 / 2,
        //   scale: {
        //     x: 1 * mult,
        //     y: 1 * mult,
        //   },
        // },
        bonusBg: {
          pattern: "stickybg_000$.png",
          start: 0,
          end: 24,
          speed: 0.5,
          loop: true,
          offsetX: 0,
          offsetY: 0,
          scale: {
            x: 1 * mult,
            y: 1 * mult,
          },
        },
        fg: {
          pattern: "money$.png",
          start: 0,
          end: 95,
          speed: 0.5,
          loop: false,
          scale: {
            x: 1,
            y: 1,
          },
          offsetX: 4 / 2,
          offsetY: -4 / 2,
          sound: "wild_shooting_sfx",
        },

        fg2Index: 0,
        fg2Data: [
          {
            pattern: "wx1_000$.png",
            start: 0,
            end: 22,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: -5,
            offsetY: 130 / 2,
          },
          {
            pattern: "wx2_000$.png",
            start: 0,
            end: 22,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: -5,
            offsetY: 130 / 2,
          },
          {
            pattern: "wx3_000$.png",
            start: 0,
            end: 22,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: -5,
            offsetY: 130 / 2,
          },
          {
            pattern: "wx4_000$.png",
            start: 0,
            end: 22,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: -5,
            offsetY: 130 / 2,
          },
          {
            pattern: "wx5_000$.png",
            start: 0,
            end: 22,
            speed: 0.5,
            loop: true,
            scale: {
              x: 0.5,
              y: 0.5,
            },
            offsetX: -5,
            offsetY: 130 / 2,
          },
        ],
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "wild",
    },
    {
      id: 12,
      IconClass: AnimatedIcon,
      icon: "02_CrystalUnstable00",
      // iconBg: "major_2_bg",
      iconBlurred: "special_blurred",
      animation: {
        fg: {
          pattern: "02_CrystalUnstable$.png",
          start: 0,
          end: 71,
          speed: 0.5,
          loop: false,
          scale: {
            x: 0.96,
            y: 0.96,
          },
        },
      },
      width: 216 / 2,
      height: 216 / 2,
      name: "special",
    },
  ],
  linesConfig: {
    lines: [
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [2, 2, 2, 2, 2],
      [0, 1, 2, 1, 0],
      [2, 1, 0, 1, 2],
      [0, 0, 1, 0, 0],
      [2, 2, 1, 2, 2],
      [1, 2, 2, 2, 1],
      [1, 0, 0, 0, 1],
    ],
    animationTime: GameConfigs.settings.game_animation ? 2300 : 1000,
  },
  reelMask: (u, d, w, h) => {
    var maskGraphics = new Graphics();
    maskGraphics.clear();
    maskGraphics.beginFill(0xffffff);
    maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
    maskGraphics.endFill();
    return maskGraphics;
  },
  reelsMask2: (u, d, w, h) => {
    var maskGraphics = new Graphics();
    maskGraphics.clear();
    maskGraphics.beginFill(0xff0000);
    maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
    maskGraphics.endFill();
    return maskGraphics;
  },
};
